'use strict';

const isInstanceOf = require('../rlink-type-utils/isInstanceOf');
const inspectableError = require('../rlink-inspectable-error');
const shape = require('../rlink-shapes/shape');
const validate = require('../rlink-shapes/validate');
const reference = require('../rlink-data-connector/reference');
const DataReference = require('../rlink-data-connector/storage/DataReference');

class BasicData {
  constructor (id, attributes) {
    if (isInstanceOf(id, Number)) {
      id = String(id);
    }

    if (!isInstanceOf(id, String)) {
      throw inspectableError`id must be a string (got ${{id}})`;
    }

    this.id = id;
    validate(attributes, shape(this.constructor.attributes), this.constructor.name);
    this.attributes = attributes;

    for (let key in this.constructor.attributes) {
      if (key in this) {
        throw new Error(`Attribute already defined in ${this.constructor.name}: ${key}`);
      }

      if ( key in attributes ) {
        this[key] = attributes[key];
      } else {
        let attrShape = this.constructor.attributes[key];

        if (typeof attrShape.makeNew === 'function') {
          // for now, just assume all values are roughly optional
          // and have defaults - later we should be explicit about
          // what those defaults are
          this[key] = attrShape.makeNew();
        } else {
          throw new Error(`Required attribute for ${this.constructor.name} is missing: ${key}`);
        }
      }

    }
  }

  static getRequestStreamProvider (request, args, _serviceArg) {
    if (!(request.name in this.requestStreamProviders)) {
      throw new Error(`${this.constructor.name} has no known requester ${request.keyFor(...args)}`);
    }
    return this.requestStreamProviders[request.name];
  }

  static referenceFor (id) {
    return reference(this, id);
  }
  get typeName () {
    return this.name;
  }

  static getReferenceType () {
    return DataReference;
  }
}

BasicData.emptyValue = null;

module.exports = BasicData;



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/BasicData.js